import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenService} from '@core/modules/authentication/services';
import {ContentTypes} from '@core/enums/content-types.enum';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  constructor(private token: TokenService) { }

  private getContentTypeHeader(req: HttpRequest<any>): HttpHeaders  {
    let headers: HttpHeaders = req.headers;
    if (!headers.has('Content-Type')) {
      headers = headers.set('Content-Type', ContentTypes.ApplicationJSON);
    }

    if (req.body instanceof FormData) {
      headers = headers.delete('Content-Type');
    }
    return headers;
  }

  private getBaseHeaders(req: HttpRequest<any>): HttpHeaders {
    const headers: HttpHeaders = this.getContentTypeHeader(req);
    return headers.set('Accept', ContentTypes.ApplicationJSON);
  }

  private getAuthorizationHeaders(req: HttpRequest<any>): HttpHeaders {
    const headers: HttpHeaders = this.getBaseHeaders(req);
    return headers.set('Auth', `JWT ${this.token.getToken()}`);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers: HttpHeaders = this.token.isToken
      ? this.getAuthorizationHeaders(req)
      : this.getBaseHeaders(req);

    req = req.clone({ headers });
    return next.handle(req);
  }
}
